import axios from "axios"
const API_URL = process.env.REACT_APP_BASE_URL;

const SUPPORT_ERROR_MESSAGE = "error occured please contact wiserep support";

const getResponseData = (response) => {
  if (!response || response.data === null || response.data === undefined) {
    throw SUPPORT_ERROR_MESSAGE;
  }

  return response.data;
};

var axiosApi = axios.create({
  baseURL: API_URL,
})
axiosApi.interceptors.response.use(function (response) {
  const statusCode = response.data.statusCode;
  // check unauthorized or expired
  if (statusCode === 1008 || statusCode === 1009) {
    localStorage.removeItem("authToken")
    localStorage.removeItem("user")
    window.location = "/login"
    return response;
  }
  else {
    return response;
  }
}, function (error) {
  return Promise.reject(error);
});

// Login Method
export const postLogin = (url, data, deviceId, platform) => {
  let configuration = { headers: { 'deviceId': deviceId, 'platform': platform } };

  return axios.post(API_URL + url, data, configuration).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }

    const responseData = getResponseData(response);

    if (!response.status) {
      throw "Please provide a valid email address and password";
    }

    return responseData;
  }).catch(err => {
    throw typeof err === "string" ? err : "Please provide a valid email address and password";
  });
};
export const postCompanyInfo = (url, data) => {
  // let configuration = { headers: { 'platform': platform } }
  return axios.post(API_URL + url, data).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    if (!response.status) {
      throw "Please provide a valid website address";
    }
    return response.data;
  }).catch(err => {
    throw "Please provide a valid website address";
  });
}
export const postSignup = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }

    const responseData = getResponseData(response);

    if (!response.status) {
      throw "Please provide a valid website address";
    }

    return responseData;
  }).catch(err => {
    throw typeof err === "string" ? err : "Please provide a valid website address";
  });
};
export const sendOTPCode = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }

    const responseData = getResponseData(response);

    if (!response.status) {
      throw "Please provide a valid phone number";
    }

    return responseData;
  }).catch(err => {
    throw typeof err === "string" ? err : "Please provide a valid phone number";
  });
};
export const makeCall = (url, data) => {
  // let configuration = { headers: { 'platform': platform } }
  return axios.post(API_URL + url, data).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    if (!response.status) {
      throw "Please provide a valid OTP";
    }
    return response.data;
  }).catch(err => {
    throw "Please provide a valid OTP";
  });
}
export const getCheckUsername = (url, params) => {
  let p = Object.keys(params).map(key => key + '=' + params[key]).join('&');

  return axios.get(API_URL + url + "?" + p).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }

    const responseData = getResponseData(response);

    if (!response.status) {
      throw "Please provide a valid Username";
    }

    return responseData;
  }).catch(err => {
    throw typeof err === "string" ? err : "Please provide a valid Username";
  });
};
export const getCheckUserTrialInfo = (url, params) => {
  // let configuration = { headers: { 'platform': platform } }
  let p = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  return axios.get(API_URL + url+ "?" + p).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    if (!response.status) {
      throw "Please provide a valid Username";
    }
    return response.data;
  }).catch(err => {
    throw "Please provide a valid Username";
  });
}
export const getCallStatus = (url, params) => {
  // let configuration = { headers: { 'platform': platform } }
  let p = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  return axios.get(API_URL + url+ "?" + p).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    if (!response.status) {
      throw "Please provide a valid Sid";
    }
    return response.data;
  }).catch(err => {
    throw "Please provide a valid Sid";
  });
}
export const postEmailOTP = (url, data) => {
  // let configuration = { headers: { 'platform': platform } }
  return axios.post(API_URL + url, data).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    if (!response.status) {
      throw "Please provide a valid email";
    }
    return response.data;
  }).catch(err => {
    throw "Please provide a valid email";
  });
}
export const postVerifyEmailOTP = (url, data) => {
  // let configuration = { headers: { 'platform': platform } }
  return axios.post(API_URL + url, data).then(response => {
    if (response.status === 400 || response.status === 500) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    if (!response.status) {
      throw "There is a problem verifying your OTP";
    }
    return response.data;
  }).catch(err => {
    throw "There is a problem verifying your OTP";
  });
}
export const postVerifyMfaSetup = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    return getResponseData(response);
  }).catch(err => {
    throw err?.response?.data?.message || "There was a problem verifying your authentication code";
  });
}
export const postVerifyMfaLogin = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    return getResponseData(response);
  }).catch(err => {
    throw err?.response?.data?.message || "There was a problem verifying your authentication code";
  });
}
export const postRecoverMfa = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    return getResponseData(response);
  }).catch(err => {
    throw err?.response?.data?.message || "There was a problem verifying your recovery code";
  });
}
export const forgotPassword = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    if (!response.data.status) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    return response.data;
  }).catch(err => {
    throw "Sorry! Something went wrong, please contact our support team";
  });
}
export const resetPassword = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    if (!response.status) {
      throw "Sorry! Something went wrong, please contact our support team";
    }
    return response.data;
  }).catch(err => {
    throw "Sorry! Something went wrong, please contact our support team";
  });
}

// Refresh Token Method
export const refreshToken = (url, data) => {
  return axios.post(API_URL + url, data).then(response => {
    return response.data;
  }).catch(err => {
    throw err;
  });
}

export async function apiWrapper(callback, url, data = {}, headers = {}) {
  const accessToken = localStorage.getItem("authToken")
  if (accessToken && accessToken.length) {
    return callback(url, data, headers, "Bearer " + accessToken)
  }
}

export async function get(url, params = {}, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  axiosApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";
  let p = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  return axiosApi.get(url + "?" + p, { headers: headers });
}

export async function post(url, data = {}, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return axiosApi.post(url, { ...data }, { headers: headers });
}

export async function postForAudio(url, data = {}, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return axiosApi.post(url, { ...data }, { headers: headers, responseType: "blob" });
}

export async function postForm(url, formData, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  let configuration = { headers: { 'content-type': 'multipart/form-data', ...headers } }
  return axiosApi.post(url, formData, configuration);
}

export async function getWithMediaHeader(url, formData = {}, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  let configuration = { headers: { 'Accept': 'audio/mpeg', ...headers }, responseType: 'arraybuffer' }
  return axiosApi.get(url, configuration);
}

export async function put(url, data, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return axiosApi.put(url, { ...data }, { headers: headers });
}

export async function putForm(url, formData, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  let configuration = { headers: { 'content-type': 'multipart/form-data', ...headers } }
  return axiosApi.put(url, formData, configuration);
}

export async function del(url, data = {}, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return await axiosApi.delete(url, { data: { ...data } }, headers);
}